import { createContext } from 'react'
import { RegisterContextType } from '../types/register'

export const initialValues = {
  payment: false,
  accountDetails: false,
  openSpinner: false,
}
const RegisterContext = createContext<RegisterContextType | null>(null)
export default RegisterContext
